// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2l-0";